module.exports = __webpack_public_path__ + "static/loading_4-d2b7122597e9c7ca117ba1401bb2cfbc.gif";